import { Form, InputNumber } from "antd";
import PropTypes from "prop-types";

const AddWorthValue = ({ worthValue, setWorthValue, t }) => (
    <div>
        <p className="text-md font-medium mb-2">{t("worthValue")}</p>
        <Form.Item>
            <InputNumber
                placeholder={t("enterWorthValue")}
                value={worthValue}
                onChange={(value) => setWorthValue(value)}
                min={0}
                style={{ width: "100%" }}
                formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            />
        </Form.Item>
    </div>
);

AddWorthValue.propTypes = {
    worthValue: PropTypes.number,
    setWorthValue: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default AddWorthValue;
